<template>
  <div class="email-template-input clearfix">
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="{
        'col-form-label col-sm-4': !options.fullWidth,
        'col-sm-12': options.fullWidth
      }">
        {{ options.label }}
      </label>
      <div :class="{
        'col-sm-8': !options.fullWidth,
        'col-sm-12': options.fullWidth
      }">
        <button class="btn btn-primary" type="button" @click="preview()">
          <span class="fa fa-eye"></span>
          &nbsp;Preview
        </button>
      </div>
    </div>
    <div class="form-group row" :class="{ 'has-feedback' : isDirty }">
      <label :for="options.name" :class="{
        'col-form-label col-sm-4': !options.fullWidth,
        'col-sm-12': options.fullWidth
      }">
        Edit {{ options.label }}
        <span v-if="options.required" class="required">*</span>
      </label>
      <div :class="{
        'col-sm-8': !options.fullWidth,
        'col-sm-12': options.fullWidth
      }">
      <textarea class="form-control" type="text"
        :id="options.name"
        @input="validate($event.target.value)"
        :value="value"
        :name="options.name"
        ref="richInput">
      </textarea>
        <span :class="validationClass" v-show="validationMessage">
          {{ validationMessage }}
        </span>
        <span :class="validationIcon" v-show="validationIcon"></span>
      </div>
    </div>
  </div>
</template>

<script>
import Modal from '../Modal'
import Api from '@/vuex/api'
import { OPEN_MODAL } from '@/vuex/types'
import {
  validationClass,
  validationIcon,
  validationMessage
} from '@/util/helpers'

export default {
  name: 'EmailTemplateInput',
  components: {
    Modal
  },
  props: {
    value: {
      type: String
    },
    options: {
      type: Object,
      default () {
        return {
          name: '',
          label: ''
        }
      }
    }
  },
  data () {
    return {
      isLength: false,
      isRegex: false,
      isValid: false,
      isDirty: false,
      minLength: 3,
      defaultVars: {},
      invalidMessage: 'Email template content is required'
    }
  },
  computed: {
    validationClass,
    validationIcon,
    validationMessage
  },
  mounted () {
    tinymce.remove(`#${this.options.name}`)
    tinymce.init({
      selector: `#${this.options.name}`,
      height: 450,
      menubar: false,
      statusbar: false,
      plugins: 'table link preview image code template',
      toolbar: 'undo redo | bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | styleselect formatselect | fontselect fontsizeselect | cut copy paste | bullist numlist | outdent indent | link unlink image | table | code',
      templates: [],
      template_replace_values: {
        companyName: '',
        companyPhone: '',
        companyLogo: '',
        homePage: ''
      },
      content_css: '/templates/email-template.css'
    })
  },
  methods: {
    async preview () {
      let api = new Api()
      let html = await api.compileEmailTemplate(this.value)
      html = `<div style='position: relative;'>${html}</div>`
      let previewModal = {
        title: 'Email Preview',
        html
      }
      this.$store.dispatch(OPEN_MODAL, previewModal)
    },
    validate () {
      tinymce.triggerSave()
      let val = this.$refs.richInput.value
      this.$emit('input', val)
      this.isDirty = true
      if (val) {
        this.isLength = this.isValid = val.length >= this.minLength
      } else if (this.options.required) {
        this.isValid = false
      } else {
        this.isValid = true
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/inputs/EmailTemplateInput.vue